import 'notie/dist/notie.css';

import Cookies from 'js-cookie';
import axios from 'axios';
import notie from 'notie';
import Promise from 'bluebird';

axios.defaults.headers.post['X-CSRFToken'] = Cookies.get('csrftoken');
axios.defaults.headers.patch['X-CSRFToken'] = Cookies.get('csrftoken');
axios.defaults.headers.delete['X-CSRFToken'] = Cookies.get('csrftoken');
axios.interceptors.response.use(null, error => {
    if ( ! error.response)
        notie.alert({type: 'error', text: 'помилка при роботі з мережою'});
    else
        notie.alert({type: 'error', text: 'помилка виконання запиту до сервера'});
    return Promise.reject(error);
});

export default axios;



// WEBPACK FOOTER //
// ./makosh/assets/axios.js